import { render } from "./VueCheckbox.vue?vue&type=template&id=50e8e432&scoped=true"
import script from "./VueCheckbox.vue?vue&type=script&lang=js"
export * from "./VueCheckbox.vue?vue&type=script&lang=js"

import "./VueCheckbox.vue?vue&type=style&index=0&id=50e8e432&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e8e432"]])

export default __exports__